<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='8' :sm='8'>
            <a-form-item label='第三方' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-input placeholder='请输入第三方' v-model='queryParam.thirdParty'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div class='table-operator' style='border-top: 5px'>
        <a-button @click='handleAdd' type='primary' icon='plus'>添加</a-button>
      </div>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        bordered
        :customRow='customRow'
        :rowClassName='rowClassName'
        @change='handleTableChange'>
        <span slot='appSecret' slot-scope='text' :title='text'>{{ truncate(text) }}</span>
        <span slot='aesKey' slot-scope='text' :title='text'>{{ truncate(text) }}</span>
        <span slot='publicKey' slot-scope='text' :title='text'>{{ truncate(text) }}</span>
        <span slot='privateKey' slot-scope='text' :title='text'>{{ truncate(text) }}</span>
        <a-tag slot='status' slot-scope='text' :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '正常' : '冻结' }}</a-tag>
        <span slot='action' slot-scope='text, record'>
          <a @click='handleActionAdd(record)'>
            <a-icon type='plus' />
            动作
          </a>
          <a-divider type='vertical' />
          <a @click='handleEdit(record)'>
            <a-icon type='edit' />
            编辑
          </a>
          <a-divider type='vertical' />
          <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record.id)'>
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>

    </div>
    <third-modal ref='modalForm' @ok='modalFormOk'></third-modal>

    <a-divider orientation='left'>
      第三方动作
      <a-tag v-if='selectedThirdParty' color='blue' closable @close='clearSelectedThirdParty'>{{ selectedThirdParty }}</a-tag>
      <a-tag v-else>全部</a-tag>
    </a-divider>

    <div class='table-page-search-wrapper'>
      <a-table
        ref='actionTable'
        rowKey='id'
        size='middle'
        :columns='actionColumns'
        :dataSource='actionDataSource'
        :pagination='actionPagination'
        :loading='actionLoading'
        bordered
        @change='handleActionTableChange'>
        <a-tag slot='status' slot-scope='text' :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '正常' : '冻结' }}</a-tag>
        <span slot='action' slot-scope='text, record'>
          <a @click='handleActionEdit(record)'>
            <a-icon type='edit' />
            编辑
          </a>
          <a-divider type='vertical' />
          <a-popconfirm title='确定删除吗?' @confirm='() => handleActionDelete(record.id)'>
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>

    </div>
    <third-action-modal ref='actionModalForm' @ok='actionModalFormOk'></third-action-modal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import moment from 'moment'
import { getThirdList, deleteThird, getThirdActionList, deleteThirdAction } from '@/webpublicapi/third'
import { getDictList } from '@/webpublicapi/dict'
import ThirdModal from './modules/ThirdModal'
import ThirdActionModal from './modules/ThirdActionModal'

export default {
  name: 'ThirdParty',
  components: { ThirdModal, ThirdActionModal },
  data() {
    return {
      dataSource: [],
      loading: false,
      // 查询条件
      queryParam: {
        thirdParty: ''
      },
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 主从联动选中的第三方
      selectedThirdId: null,
      selectedThirdParty: '',
      // 下方动作表
      actionDataSource: [],
      actionLoading: false,
      // 动作字典（itemValue=库存key，itemText=展示名）
      actionList: [],
      actionPagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '第三方',
          align: 'left',
          dataIndex: 'thirdParty'
        },
        {
          title: '名称',
          align: 'left',
          dataIndex: 'thirdName'
        },
        {
          title: '对接Key',
          align: 'left',
          dataIndex: 'appKey'
        },
        {
          title: '对接密钥',
          align: 'left',
          dataIndex: 'appSecret',
          scopedSlots: { customRender: 'appSecret' }
        },
        {
          title: 'AES Key',
          align: 'left',
          dataIndex: 'aesKey',
          scopedSlots: { customRender: 'aesKey' }
        },
        {
          title: '平台公钥',
          align: 'left',
          dataIndex: 'publicKey',
          scopedSlots: { customRender: 'publicKey' }
        },
        {
          title: '应用私钥',
          align: 'left',
          dataIndex: 'privateKey',
          scopedSlots: { customRender: 'privateKey' }
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updatedTime',
          customRender: (text) => this.formatDateTime(text)
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ],
      actionColumns: [
        {
          title: '第三方',
          align: 'left',
          dataIndex: 'thirdParty',
          customRender: (text, record) => record.thirdName || text
        },
        {
          title: '动作',
          align: 'left',
          dataIndex: 'action',
          customRender: (text) => this.actionName(text)
        },
        {
          title: '地址',
          align: 'left',
          dataIndex: 'url'
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updatedTime',
          customRender: (text) => this.formatDateTime(text)
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
    this.loadActionData(1)
    this.loadActionList()
  },
  methods: {
    // 更新时间：时间戳(秒/毫秒)转年月日时分秒，日期字符串原样
    formatDateTime(text) {
      if (text === null || text === undefined || text === '') {
        return ''
      }
      const value = String(text)
      if (/^\d+$/.test(value)) {
        const time = value.length <= 10 ? Number(value) * 1000 : Number(value)
        return moment(time).format('YYYY-MM-DD HH:mm:ss')
      }
      return text
    },
    // 动作 key 映射字典展示名，无匹配回退原值
    actionName(key) {
      const action = this.actionList.find(item => item.itemValue === key)
      return (action && action.itemText) || key
    },
    loadActionList() {
      getDictList().then(res => {
        if (res.code === 1000 && res.data.third_action) {
          this.actionList = res.data.third_action
        }
      })
    },
    // 密钥列截断展示，悬停显示完整值
    truncate(text) {
      const value = text || ''
      return value.length > 14 ? value.slice(0, 6) + '...' + value.slice(-4) : value
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      const params = {
        thirdParty: this.queryParam.thirdParty,
        pageNum: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }
      getThirdList(filterObj(params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    },
    // 主从联动：点击上方行选中第三方
    customRow(record) {
      return {
        on: {
          click: () => this.selectThirdParty(record)
        }
      }
    },
    rowClassName(record) {
      return record.id === this.selectedThirdId ? 'third-row-selected' : ''
    },
    selectThirdParty(record) {
      // 再次点击同一行取消选中，显示全部动作
      if (this.selectedThirdId === record.id) {
        this.clearSelectedThirdParty()
        return
      }
      this.selectedThirdId = record.id
      this.selectedThirdParty = record.thirdParty
      this.loadActionData(1)
    },
    clearSelectedThirdParty() {
      this.selectedThirdId = null
      this.selectedThirdParty = ''
      this.loadActionData(1)
    },
    handleAdd() {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
    },
    handleDelete(id) {
      deleteThird({ id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
          // 选中的第三方被删除后联动清空
          const deleted = this.dataSource.find(item => item.id === id)
          if (deleted && deleted.thirdParty === this.selectedThirdParty) {
            this.selectedThirdId = null
            this.selectedThirdParty = ''
            this.loadActionData(1)
          }
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    searchReset() {
      this.queryParam.thirdParty = ''
      this.loadData(1)
    },
    // model回调
    modalFormOk() {
      this.loadData()
    },
    loadActionData(arg) {
      if (arg === 1) {
        this.actionPagination.current = 1
      }
      this.actionLoading = true
      // 动作列表仅按主从联动的选中行过滤
      const params = {
        thirdParty: this.selectedThirdParty,
        pageNum: this.actionPagination.current,
        pageSize: this.actionPagination.pageSize
      }
      getThirdActionList(filterObj(params)).then((res) => {
        if (res.code === 1000) {
          this.actionPagination.total = res.data.total
          this.actionDataSource = res.data.rows
        } else {
          this.actionPagination.total = 0
          this.actionDataSource = []
          this.$message.error(res.msg)
        }
        this.actionLoading = false
      }).catch(e => {
        this.actionLoading = false
        this.$message.error(e.message)
      })
    },
    handleActionTableChange(pagination) {
      this.actionPagination = pagination
      this.loadActionData()
    },
    // 从第三方行操作栏新增动作：归属锁定为当前行
    handleActionAdd(record) {
      this.$refs.actionModalForm.defaultThirdParty = record.thirdParty
      this.$refs.actionModalForm.add()
      this.$refs.actionModalForm.title = '新增'
    },
    handleActionEdit(record) {
      this.$refs.actionModalForm.edit(record)
      this.$refs.actionModalForm.title = '编辑'
    },
    handleActionDelete(id) {
      deleteThirdAction({ id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadActionData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    actionModalFormOk() {
      this.loadActionData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .third-row-selected td {
  background: #e6f7ff;
}
</style>
